import axiosMain from "../../../http/axios/axios_main";

export const fetchReportDataTcsDetails = async (requestPayload) => {
  try {
    const response = await axiosMain.post(
      "/report/tcsDetailsAuctioneerInvoicesFactoryOwnerReport", 
      requestPayload 
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report data:", error);
    if (error.response) {
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      throw new Error("No response received from the server.");
    } else {
      throw new Error("Error in setting up the request: " + error.message);
    }
  }
};



export const fetchReportDataTdsDetails = async (requestPayload) => {
  try {
    const response = await axiosMain.post(
      "report/tdsInvoiceReportAuctioneer", 
      requestPayload 
    );
    return response.data[0];
  } catch (error) {
    console.error("Error fetching report data:", error);
    if (error.response) {
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      throw new Error("No response received from the server.");
    } else {
      throw new Error("Error in setting up the request: " + error.message);
    }
  }
};



export const AuctioneerListDetails = async (requestPayload) => {
  console.log(requestPayload,"check_requestPayload")
  try {
    const response = await axiosMain.post(
      "postauction/dealbook/getauctioneerbysaleandseason", 
      requestPayload 
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report data:", error);
    if (error.response) {
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      throw new Error("No response received from the server.");
    } else {
      throw new Error("Error in setting up the request: " + error.message);
    }
  }
};


export const getWarehouseUserInvoice = async (requestPayload) => {
  try {
    const response = await axiosMain.post(
      "postauction/Report/getWarehouseUserInvoice", 
      requestPayload 
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report data:", error);
    if (error.response) {
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      throw new Error("No response received from the server.");
    } else {
      throw new Error("Error in setting up the request: " + error.message);
    }
  }
};


export const categoryWiseSoldQty = async (requestPayload) => {
  try {
    const response = await axiosMain.post(
      "report/month-categorywise-soldqty-list", 
      requestPayload 
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report data:", error);
    if (error.response) {
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      throw new Error("No response received from the server.");
    } else {
      throw new Error("Error in setting up the request: " + error.message);
    }
  }
};


export const buyerPaymentStatusReport = async (requestPayload) => {
  try {
    const response = await axiosMain.post(
      "report/buyerPaymentStatusReport", 
      requestPayload 
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report data:", error);
    if (error.response) {
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      throw new Error("No response received from the server.");
    } else {
      throw new Error("Error in setting up the request: " + error.message);
    }
  }
};


export const getSaleProgramDetails = async (requestPayload) => {
  try {
    const response = await axiosMain.post(
      "preauction/Common/GetSaleProgramDetails", 
      requestPayload 
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report data:", error);
    if (error.response) {
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      throw new Error("No response received from the server.");
    } else {
      throw new Error("Error in setting up the request: " + error.message);
    }
  }
};